/*@ngInject*/
const ColumnHeaderController = function ($element, formComponentUtil, fieldType, xmlUtil, formMediator, appTypeConfigurationModel, formatUtil) {

    let fieldStructureList;

    function buildFieldInstanceList() {
        let fieldTemplateId = this.uiField.fieldTemplate.id,
            fieldModel,
            isMatchingFieldTemplateId;

        fieldStructureList = [];

        _.each(this.row.rowList, function (row) {
            _.each(row.fieldStructureList, function (fieldStructure) {
                isMatchingFieldTemplateId = fieldStructure.uiField.fieldTemplate.id === fieldTemplateId;

                if (isMatchingFieldTemplateId) {
                    fieldStructureList.push(fieldStructure);
                }
            });
        });
    }

    this.$onInit = function () {
        let rowRepeaterId = this.row.rowRepeaterId,
            sortKey = this.uiField.fieldTemplate.variableName,
            sortType;

        this.isRowNumberColumn = this.uiField.fieldTemplate.variableName === 'rowNumber';
        this.currentSortType = 'none';
        this.currentSortKey = 'none';
        this.updateSortValues();

        buildFieldInstanceList.call(this);
        this.setupDynamicProperties();

        if (this.isActiveSort) {
            rowRepeaterId = this.row.rowRepeaterId;
            sortKey = this.uiField.fieldTemplate.variableName;

            formMediator.sortRowRepeater(this.rootFormId, rowRepeaterId, sortKey, this.currentSortType);
        }
    };

    this.$onChanges = function () {
        buildFieldInstanceList.call(this);
        this.setupDynamicProperties();

        this.updateSortValues();
    };

    this.getHeaderFieldWidth = function () {
        const
            uiField = this.uiField,
            isSpacer = uiField.fieldTemplate.type === fieldType.SPACER,
            isUploadAttachmentButton = uiField.fieldTemplate.type === fieldType.UPLOAD_ATTACHMENT_BUTTON,
            isFunctionButton = uiField.fieldTemplate.type === fieldType.FUNCTION_BUTTON,
            isYesNo = uiField.fieldTemplate.type === fieldType.YES_NO,
            inputContainerWidth = 160;

        let layout,
            options,
            result;

        if (!_.isNil(uiField.fieldTemplate.type)) {
            const layout = formComponentUtil.buildLayoutProperties(uiField);
            result = layout.inputWidth || layout.labelWidth;

            if (isSpacer) {
                const options = xmlUtil.parseString(uiField.options);
                result = parseInt(options.width);
                if (this.configurable) {
                    result = parseInt(options.width) < 18 ? 18 : options.width;
                }
            }
            else if (isUploadAttachmentButton || isFunctionButton) {
                result = layout.labelWidth || inputContainerWidth;
            }
            else if (isYesNo) {
                result = layout.labelWidth > inputContainerWidth ? layout.labelWidth : inputContainerWidth;
            }
        }
        return result;
    };

    this.getHeaderLabel = function () {
        let uiField = this.uiField,
            isSpacer = uiField.fieldTemplate.type === fieldType.SPACER,
            isUploadAttachmentButton = uiField.fieldTemplate.type === fieldType.UPLOAD_ATTACHMENT_BUTTON,
            isFunctionButton = uiField.fieldTemplate.type === fieldType.FUNCTION_BUTTON;

        return (isSpacer || isUploadAttachmentButton ||  isFunctionButton)? '' : uiField.displayLabel;
    };

    this.setupDynamicProperties = function () {
        let form = this.row.parentForm,
            uiField = this.uiField,
            fieldTemplate = uiField.fieldTemplate,
            rowTemplate = this.row.rowTemplate,
            rowList = this.row.rowList,
            fieldModel;

        function setupValidity() {
            let result = true;

            _.each(fieldStructureList, function (fieldStructure) {
                fieldModel = fieldStructure.fieldModel || {};

                if (fieldModel.valid === false) {
                    result = false;
                }
            });
            return result;
        }

        function setupConfigurable() {
            let result = true;

            _.each(fieldStructureList, function (fieldStructure) {
                result = fieldStructure.isConfigurableComponent;
                return;
            });
            return result;
        }

        function setupRequired() {
            let result = formComponentUtil.isFieldRequired(form, null, fieldTemplate),
                isOptionallyRequired = formComponentUtil.isFieldRequired(form, null, rowTemplate.repeaterField.fieldTemplate) === false,
                isRequired;

            _.each(fieldStructureList, function (fieldStructure) {
                isRequired = formComponentUtil.isFieldRequired(form, fieldStructure.fieldModel, fieldTemplate);
                if (isRequired) {
                    result = true;
                }
            });

            if (isOptionallyRequired) {
                if (anyRowHasValue() || rowList.length > 1) {
                    result = result;
                } else {
                    result = false;
                }
            }

            _.each(fieldStructureList, function (fieldStructure) {
                if (isOptionallyRequired) {
                    fieldStructure.dynamicProperties.isOptionallyRequired = true;
                    fieldStructure.dynamicProperties.isColumnRequired = result;
                } else {
                    fieldStructure.dynamicProperties.isOptionallyRequired = false;
                }
            });

            return result;
        }

        function anyRowHasValue() {
            let result = false,
                fieldModel;

            _.each(rowList, function (row) {
                _.each(row.fieldStructureList, function (fieldStructure) {
                    fieldModel = fieldStructure.fieldModel || {};
                    if (!_.isEmpty(fieldModel.value) && fieldStructure.uiField.fieldTemplate.type !== fieldType.ROWREPEATER && (!fieldStructure.uiField.fieldTemplate.hidden || (fieldStructure.uiField.fieldTemplate.hidden && !fieldModel.hidden ))){
                        result = true;
                    }
                });
            });

            return result;
        }

        function allRowsHaveValue() {
            let allRowsHaveValue = true,
                allRowsHaveInstance = rowList.length === fieldStructureList.length,
                fieldModel;

            _.each(fieldStructureList, function (fieldStructure) {
                fieldModel = fieldStructure.fieldModel || {};
                
                if (_.isEmpty(fieldModel.value) && formComponentUtil.isFieldRequired(form, fieldModel, fieldTemplate) && (!fieldStructure.uiField.fieldTemplate.hidden || (fieldStructure.uiField.fieldTemplate.hidden && ! _.isEmpty(fieldModel) && !fieldModel.hidden ))) {
                    allRowsHaveValue = false;
                }
            });

            return allRowsHaveValue && allRowsHaveInstance;
        }

        function setupHidden() {
            let result = false,
                numberOfFields = 0,
                numberOfVisibleFields = 0;

            _.each(fieldStructureList, function (fieldStructure) {
                if (fieldStructure.fieldModel) {
                    numberOfFields++;
                    if (!fieldStructure.fieldModel.hidden) {
                        numberOfVisibleFields++;
                    }
                }
            });

            /*
             * If there are any fields in the column, hide the column if none of the fields
             * are visible. If there aren't any fields in the column, then hide the column
             * if the field template says that the field should be hidden.
             * Even if those checks say that the column should not be hidden, hide the column
             * if the field template says that the column should not be visible for
             * the current user type.
             */
            result = ((numberOfFields > 0 ? numberOfVisibleFields === 0 : fieldTemplate.hidden) ||
                (appTypeConfigurationModel.isUnderwriterWorkstation() ? !fieldTemplate.carrierVisible : !fieldTemplate.agencyVisible));
            return result;
        }

        function setupCollapsedColumn() {
            let variableName = fieldTemplate.variableName,
                result = false,
                isCorrectColumn;

            _.each(rowList, function (row) {
                _.each(row.fieldStructureList, function (fieldStructure) {
                    isCorrectColumn = fieldStructure.uiField.fieldTemplate.variableName === variableName;
                    if (isCorrectColumn && fieldStructure.isColumnCollapsed) {
                        result = true;
                    }
                });
            });

            return result;
        }

        if (!this.isRowNumberColumn) {
            this.hasValue = allRowsHaveValue();
            this.isRequired = setupRequired();
            this.isValid = setupValidity();
            this.configurable = setupConfigurable();
            this.hidden = this.configurable ? false : setupHidden();
            this.isColumnCollapsed = this.configurable ? false : setupCollapsedColumn();
        }
        else if (uiField.hidden) {
            this.hidden = true;
        }

        this.requiredIndicatorLabelConfig = {
            required: this.isRequired,
            valid: this.isValid,
            hasValue: this.hasValue,
            label: this.getHeaderLabel(),
            width: this.getHeaderFieldWidth(),
            configurable: this.configurable,
            bold: this.uiField.labelFontStyle === 'Bold'
        };

        if (this.hidden && this.isColumnCollapsed) {
            $element.addClass('collapsed');
        } else {
            $element.removeClass('collapsed');
        }
    };

    this.updateSortValues = function () {
        let rowRepeaterSort = this.row.sort || {},
            sortKey = this.uiField.fieldTemplate.variableName;

        this.isActiveSort = rowRepeaterSort.sortKey === sortKey;
        this.currentSortType = rowRepeaterSort.sortType;
        this.isSortingAsc = this.isActiveSort && rowRepeaterSort.sortType === 'asc';
        this.isSortingDesc = this.isActiveSort && rowRepeaterSort.sortType === 'desc';
    };

    this.toggleSort = function () {
        const form = this.row.parentForm,
              rowRepeaterId = this.row.rowRepeaterId,
              sortKey = this.uiField.fieldTemplate.variableName,
              allowSort = !form.isConfigurableForm;
        let sortType;

        if (allowSort) {
            if (this.currentSortType === 'asc') {
                sortType = 'desc';
            } else if (this.currentSortType === 'desc') {
                sortType = 'asc';
            }
            formMediator.sortRowRepeater(this.rootFormId, rowRepeaterId, sortKey, sortType);
        }
    };

    this.getComponentClassName = function (uiField) {
        return `rowRepeaterColumnHeader-${formatUtil.formatAsSelector(uiField.fieldTemplate.variableName)}`;
    };
};

angular.module('umFormViewer')
    .controller('columnHeaderController', ColumnHeaderController);
